import { deleteAnswerSetIfUnused } from './answer-set-actions';

export function updateCapabilityElement(doc, elementGuid, updates) {
  const capabilityElements = doc.getMap('capabilityElements');
  const element = capabilityElements.get(elementGuid);
  if (!element) {
    return;
  }

  doc.transact(() => {
    Object.entries(updates).forEach(([key, value]) => {
      element.set(key, value);
    });
  });
}

/** The capability pages that ask a capability question. */
export function getPagesUsingCapabilityElement(pages, elementGuid) {
  return (pages ?? []).filter(
    (page) =>
      page.type === 'capability-questions' &&
      (page.capabilityElements ?? []).some((e) => e.guid === elementGuid)
  );
}

/**
 * Removes a capability question from the assessment: off every page that asks
 * it, then from the question bank, along with its own answer set.
 */
export function removeCapabilityElement(doc, elementGuid) {
  const capabilityElements = doc.getMap('capabilityElements');
  const answerSetGuid = capabilityElements.get(elementGuid)?.get('answerSetId');

  doc.transact(() => {
    doc.getMap('pages').forEach((page) => {
      page.get('capabilityElementPositions')?.delete(elementGuid);
    });
    capabilityElements.delete(elementGuid);
    deleteAnswerSetIfUnused(doc, answerSetGuid);
  });
}
